import { gql } from 'graphql-tag';
import { baseResponseGraphqlField } from '../../../base.graphql';

export const benefitFields = `
  id
  uniqueId
  content
`;

export const CREATE_BENEFIT = gql`
  mutation CreateBenefitMutation($input: BenefitInputObject!) {
    createBenefitMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${benefitFields}
      }
    }
  }
`;

export const UPDATE_BENEFIT = gql`
  mutation UpdateBenefitMutation($input: BenefitInputObject!) {
    updateBenefitMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${benefitFields}
      }
    }
  }
`;

export const DELETE_BENEFIT = gql`
  mutation DeleteBenefitMutation($uniqueId: String!) {
    deleteBenefitMutation(uniqueId: $uniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`;

export const GET_BENEFITS = gql`
  query GetBenefits($filtering: BenefitFilteringInputObject) {
    getBenefits(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${benefitFields}
      }
    }
  }
`;
